import { BasicModel } from "../basic/basic.model";
import { SocieteModel } from "../simple-types/societe.model";
import { SocieteLinkedModel } from "./societe-linked.model";

export class PeriodeSageModel extends BasicModel {
    annee: number;
    mois: number;
    date: Date;
    statut: string;
    idSociete: number;
    societe: SocieteModel;
}